var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Children, createRef, isValidElement, useEffect, useRef, useState, } from 'react';
import { Portal } from '../portal';
import { Overlay } from '../overlay';
import { useAnimateTransition, useId } from '../hooks';
import { logError } from '../helpers';
import AlertHeader from '../alert-dialog/header'; // TODO: Refactor once modal is a separate component - ixTec
import AlertBody from '../alert-dialog/body'; // TODO: Refactor once modal is a separate component - ixTec
import Panel from './panel';
import Header from './header';
import { DialogProvider } from './dialog-context';
import { MESSAGES } from './debug-messages';
import Body from './body';
function DialogInternal(_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, closeButtonOverride = _a.closeButtonOverride, _b = _a.alignCenter, alignCenter = _b === void 0 ? false : _b, children = _a.children, ariaLabel = _a["aria-label"], _c = _a.role, role = _c === void 0 ? 'dialog' : _c, restProps = __rest(_a, ["isOpen", "onClose", "closeButtonOverride", "alignCenter", "children", 'aria-label', "role"]);
    var id = "modal-".concat(useId());
    var didMount = useRef(false);
    var isAnimating = useAnimateTransition(isOpen, 300);
    var autoFocusRef = createRef();
    var _d = __read(useState(), 2), headerId = _d[0], setHeaderId = _d[1];
    var _e = __read(useState(), 2), bodyId = _e[0], setBodyId = _e[1];
    var _f = __read(useState(false), 2), hasDecorativeHeader = _f[0], setHasDecorativeHeader = _f[1];
    useEffect(function () {
        Children.toArray(children).forEach(function (child) {
            if (isValidElement(child)) {
                if (child.type === Header || child.type === AlertHeader) {
                    setHeaderId("".concat(id, "-header"));
                    setHasDecorativeHeader(child.props.mode === 'decorative');
                }
                else if (child.type === Body || child.type === AlertBody) {
                    !ariaLabel && setBodyId("".concat(id, "-body"));
                }
            }
        });
    }, [ariaLabel, children, id]);
    // Handle avoiding checking for headerId before initial render
    useEffect(function () {
        if (didMount.current && !headerId) {
            logError(MESSAGES.MISSING_HEADER);
        }
        didMount.current = true;
    }, [headerId, id]);
    return (_jsx(DialogProvider, __assign({}, { headerId: headerId, bodyId: bodyId, hasDecorativeHeader: hasDecorativeHeader, alignCenter: alignCenter, autoFocusRef: autoFocusRef }, { children: _jsx(Portal, { children: isAnimating && (_jsx(Overlay, __assign({ isVisible: isOpen, "data-testid": "modal-overlay" }, { children: _jsx(Panel, __assign({}, __assign({ role: role, isVisible: isOpen, onClose: onClose, closeButtonOverride: closeButtonOverride, ariaLabel: ariaLabel }, restProps), { children: children })) }))) }) })));
}
export default DialogInternal;
